import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  height: 44px;\n  padding: 0;\n  min-width: 17px;\n  background-color: transparent;\n  flex: 1;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  border: 0;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  background-color: transparent;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  padding-right: 16px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  justify-content: end;\n  height: 100%;\n  align-items: center;\n  position: relative;\n  margin: auto;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0.6;\n  font-size: 12px;\n  color: ", ";\n  font-weight: 500;\n  line-height: 22px;\n  ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 16px;\n  font-weight: 600;\n  margin: 0;\n  color: ", ";\n\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n          opacity: ", ";\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          visibility: hidden;\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  justify-content: end;\n  height: 100%;\n  align-items: center;\n  position: relative;\n  margin: auto;\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          opacity: ", ";\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          visibility: hidden;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  flex: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  white-space: nowrap;\n  position: relative;\n  align-items: center;\n\n  ", ";\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height:64px;\n  width: 100%;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 20px;\n  \n  /* This will be commented out until we figure out how to re-render component on scroll\n  ", "\n  */\n\n  background: ", ";\n\n  ", ";\n      \n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  font-size: 14px;\n  font-weight: 600;\n  height: 64px;\n  justify-content: space-between;\n  left: 0;\n  ", ";\n  top: ", ";\n  width: 100%;\n  z-index: 20;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled, { css } from '../utils/styling/styled-components';
import { ACTION_STRIP_TITLE, ACTION_STRIP_SUBTEXT, BACK_BUTTON } from '../utils/testing/TestIDs';
import { theme } from '../theme';
import { useScrollHeight } from '../ActionStrip/hooks';
var Wrapper = styled.div(_templateObject(), function (props) {
  return props.sticky && 'position: fixed';
}, function (props) {
  return props.isSBNavEnabled ? '0px' : '70px';
});
var Container = styled.div(_templateObject2(), function (props) {
  return props.scrollPercent >= 0.1 && 'box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.04);';
}, function (props) {
  return props.scrollHeight <= props.verticalScrollHeight ? props.invertedStripColor : props.invertedStripTransitionColor;
}, function (props) {
  return props.scrollPercent < 0.1 && 'background: transparent';
});
var TitleArea = styled.div(_templateObject3(), function (props) {
  return props.verticalSubText && "\n    flex-direction: column;\n    ";
}, function (props) {
  switch (props.visibilityMode) {
    case 'none':
      return css(_templateObject4());

    case 'onscroll':
      return css(_templateObject5(), props.scrollPercent);

    default:
      return '';
  }
});
var ActionArea = styled.div(_templateObject6(), function (props) {
  switch (props.visibilityMode) {
    case 'none':
      return css(_templateObject7());

    case 'onscroll':
      return css(_templateObject8(), props.scrollPercent);

    default:
      return '';
  }
});
var Title = styled.span(_templateObject9(), function (props) {
  return props.titleColorOnLoad || props.theme.colors.slate;
}, function (props) {
  return props.scrollHeight >= props.verticalScrollHeight && "color:".concat(theme.colors.slate);
});
var Subtext = styled.span(_templateObject10(), function (props) {
  return props.subtextColorOnLoad;
}, function (props) {
  return props.scrollHeight >= props.verticalScrollHeight && "color:".concat(theme.colors.slate);
});
var Action = styled.div(_templateObject11());
var MobileActionContainer = styled.div(_templateObject12());
var MobileButton = styled.button(_templateObject13());
var Button = styled.button(_templateObject14());
var NoActionContainer = styled.div(_templateObject15());
export var MobileStripV2 = function MobileStripV2(_ref) {
  var title = _ref.title,
      subtext = _ref.subtext,
      action = _ref.action,
      onBack = _ref.onBack,
      _ref$backIcon = _ref.backIcon,
      backIcon = _ref$backIcon === void 0 ? AcornsIcon.Icon.ArrowLeft : _ref$backIcon,
      titleVisibility = _ref.titleVisibility,
      className = _ref.className,
      _ref$titleTestId = _ref.titleTestId,
      titleTestId = _ref$titleTestId === void 0 ? ACTION_STRIP_TITLE : _ref$titleTestId,
      _ref$subtextTestId = _ref.subtextTestId,
      subtextTestId = _ref$subtextTestId === void 0 ? ACTION_STRIP_SUBTEXT : _ref$subtextTestId,
      _ref$showBackButton = _ref.showBackButton,
      showBackButton = _ref$showBackButton === void 0 ? true : _ref$showBackButton,
      _ref$verticalScrollHe = _ref.verticalScrollHeight,
      verticalScrollHeight = _ref$verticalScrollHe === void 0 ? 6 : _ref$verticalScrollHe,
      invertedScrollIcon = _ref.invertedScrollIcon,
      invertedChildrenIcons = _ref.invertedChildrenIcons,
      invertedChildrenIconsScrolled = _ref.invertedChildrenIconsScrolled,
      _ref$invertedStripCol = _ref.invertedStripColor,
      invertedStripColor = _ref$invertedStripCol === void 0 ? theme.colors.white : _ref$invertedStripCol,
      _ref$invertedStripTra = _ref.invertedStripTransitionColor,
      invertedStripTransitionColor = _ref$invertedStripTra === void 0 ? theme.colors.white : _ref$invertedStripTra,
      _ref$verticalSubText = _ref.verticalSubText,
      verticalSubText = _ref$verticalSubText === void 0 ? true : _ref$verticalSubText,
      _ref$titleColorOnLoad = _ref.titleColorOnLoad,
      titleColorOnLoad = _ref$titleColorOnLoad === void 0 ? theme.colors.slate : _ref$titleColorOnLoad,
      _ref$subtextColorOnLo = _ref.subtextColorOnLoad,
      subtextColorOnLoad = _ref$subtextColorOnLo === void 0 ? theme.colors.slate : _ref$subtextColorOnLo,
      _ref$sticky = _ref.sticky,
      sticky = _ref$sticky === void 0 ? true : _ref$sticky,
      backIconHeight = _ref.backIconHeight,
      backIconWidth = _ref.backIconWidth,
      isSBNavEnabled = _ref.isSBNavEnabled;
  //TODO scroll Percent is not being called on scroll when embedded in page component
  var scrollPercent = 0.2;

  var _useScrollHeight = useScrollHeight({
    scrollDistance: 64
  }),
      scrollHeight = _useScrollHeight.scrollHeight;

  return /*#__PURE__*/React.createElement(Wrapper, {
    sticky: sticky,
    isSBNavEnabled: isSBNavEnabled
  }, /*#__PURE__*/React.createElement(Container, {
    scrollPercent: scrollPercent,
    className: className,
    verticalScrollHeight: verticalScrollHeight,
    invertedStripColor: invertedStripColor,
    invertedStripTransitionColor: invertedStripTransitionColor,
    scrollHeight: scrollHeight
  }, showBackButton && /*#__PURE__*/React.createElement(Button, {
    onClick: onBack,
    "data-testid": BACK_BUTTON
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: invertedScrollIcon ? scrollHeight <= verticalScrollHeight ? backIcon : invertedScrollIcon : backIcon,
    width: backIconWidth ? backIconWidth : '17px',
    height: backIconHeight ? backIconHeight : '12px'
  })), /*#__PURE__*/React.createElement(TitleArea, {
    verticalSubText: verticalSubText,
    scrollPercent: scrollPercent,
    visibilityMode: titleVisibility
  }, title && /*#__PURE__*/React.createElement(Title, {
    scrollHeight: scrollHeight,
    verticalScrollHeight: verticalScrollHeight,
    titleColorOnLoad: titleColorOnLoad,
    "data-testid": titleTestId
  }, title), subtext && /*#__PURE__*/React.createElement(Subtext, {
    scrollHeight: scrollHeight,
    verticalScrollHeight: verticalScrollHeight,
    subtextColorOnLoad: subtextColorOnLoad,
    "data-testid": subtextTestId
  }, subtext)), invertedChildrenIcons && invertedChildrenIconsScrolled && /*#__PURE__*/React.createElement(ActionArea, {
    scrollPercent: scrollPercent,
    visibilityMode: titleVisibility
  }, scrollHeight <= verticalScrollHeight ? invertedChildrenIcons.map(function (child) {
    return /*#__PURE__*/React.createElement(MobileActionContainer, null, /*#__PURE__*/React.createElement(MobileButton, {
      onClick: child.action
    }, child.icon));
  }) : invertedChildrenIconsScrolled.map(function (child) {
    return /*#__PURE__*/React.createElement(MobileActionContainer, null, /*#__PURE__*/React.createElement(MobileButton, {
      onClick: child.action
    }, child.icon));
  })), action && /*#__PURE__*/React.createElement(Action, null, action), !action && !invertedChildrenIcons && /*#__PURE__*/React.createElement(NoActionContainer, null)));
};